import { Component, EventEmitter, inject, input, Output, ChangeDetectionStrategy } from '@angular/core';
import { NamespaceType, NamespaceUtils } from '../../core/utils/namespace-utils';

import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatOption } from '@angular/material/autocomplete';
import { MatSelect } from '@angular/material/select';
import { Namespace } from '@vendasta/protos/ai_assistants/v1alpha1';
import { MatButtonModule } from '@angular/material/button';

interface NamespaceFilter {
  value: NamespaceType;
  label: string;
  hasId?: boolean;
  idLabel?: string;
}

@Component({
  selector: 'ai-namespace-selector',
  imports: [
    GalaxyFormFieldModule,
    MatRadioModule,
    ReactiveFormsModule,
    MatInputModule,
    MatOption,
    MatSelect,
    FormsModule,
    MatButtonModule,
  ],
  templateUrl: './namespace-selector.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './namespace-selector.component.scss',

})
export class NamespaceSelectorComponent {
  private fb = inject(FormBuilder);
  protected readonly NamespaceUtils = NamespaceUtils;
  @Output() selected = new EventEmitter<Namespace>();
  namespaceIdRequired = input<boolean>();

  namespaceTypeOptions: NamespaceFilter[] = [
    { value: NamespaceType.ALL, label: 'All' },
    { value: NamespaceType.SYSTEM, label: 'System' },
    { value: NamespaceType.GLOBAL, label: 'Global' },
    { value: NamespaceType.ACCOUNT_GROUP, label: 'Account group', hasId: true, idLabel: 'Account group ID' },
    { value: NamespaceType.PARTNER, label: 'Partner', hasId: true, idLabel: 'Partner ID' },
  ];

  form = new FormGroup({
    namespaceType: new FormControl(this.namespaceTypeOptions[0]),
    namespaceId: new FormControl(''),
  });

  namespaceTypeChange(namespaceType: NamespaceFilter): void {
    if (this.namespaceIdRequired()) {
      if (namespaceType.hasId) {
        this.form.get('namespaceId')?.setValidators([Validators.required]);
      } else {
        this.form.get('namespaceId')?.clearValidators();
        this.form.get('namespaceId')?.updateValueAndValidity();
        this.submit();
      }
    } else {
      this.submit();
    }
  }

  submit(): void {
    this.selected.emit(NamespaceUtils.toNamespace(this.form.value.namespaceType.value, this.form.value.namespaceId));
  }
}
